module.exports = __webpack_public_path__ + "img/resource-tech-image-26.e47003b7.jpg";